module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-1f704955.png";